import { Place } from './Dto';

export class Util {
  static contains(text: string, search: string): boolean {
    if (!search || search === '') {
      return true;
    }
    if (!text || text === '') {
      return false;
    }

    const keys:Array<string> = search.toLocaleLowerCase().split(" ");
    const matches = keys.filter(key => {
      if (key.trim() === '') {
        return true;
      }
      return text.toLocaleLowerCase().indexOf(key) >= 0;
    });
    return matches.length === keys.length;
  }

  static concat(array:Array<string>, text:string):Array<string> {
    if (text) {
      array = array.concat(text.split(' '));
    }
    return array;
  }

  static address(place: Place) {
    let address = place.address.number + ' ' + place.address.street;
    address += ', ' + place.address.suburb;
    address += place.address.district ? ', ' + place.address.district : '';
    return address;
  }

  static getTrackingUrl(view:string, search:string) {
    let url = '/' + view.toLowerCase();
    if (search && search.length > 0) {
      url += '?q=' + search; 
    }
    return url;
  }

  static getPlaceLink(place:Place) {
    if (place.id) {
      const id = place.id.find(id => id.indexOf("google:") == 0);
      if (id) {
        return 'https://www.google.com/maps/search/?api=1&query=Google&query_place_id=' + id.split(":")[1];
      }
    }
    return 'https://maps.google.com/?q=' + place.latlng;
  }
}
